import Vue from 'vue'
import VueI18n from 'vue-i18n'
import stringsRu from "./strings_ru";
import stringsEn from "./strings_en";
import {getCookie, setCookie} from "./utils";

Vue.use(VueI18n);

export enum Locale {
    EN = 'en',
    RU = 'ru',
}

const DEFAULT_LANG = Locale.RU;
const SELECTED_LANG_COOKIE = 'selectedLang';
const savedLocale = getSavedLang();

export function setLocale(locale: Locale) {
    i18n.locale = locale;
    setCookie(SELECTED_LANG_COOKIE, locale, Infinity);
}

export const i18n = new VueI18n({
    locale: savedLocale,
    fallbackLocale: DEFAULT_LANG,
    messages: {
        [Locale.RU]: stringsRu,
        [Locale.EN]: stringsEn,
    },
    pluralizationRules: {
        'ru': function (choice: any, choicesLength: any) {

            if (choice === 0) {
                return 0;
            }

            const teen = choice > 10 && choice < 20;
            const endsWithOne = choice % 10 === 1;

            if (choicesLength < 4) {
                return (!teen && endsWithOne) ? 1 : 2;
            }
            if (!teen && endsWithOne) {
                return 1;
            }
            if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
                return 2;
            }

            return (choicesLength < 4) ? 2 : 3;
        }
    }
});

function getSavedLang() {
    let lang = getCookie(SELECTED_LANG_COOKIE);
    return lang ? lang : DEFAULT_LANG;
}
